import L_HTML5 from "../../assets/img/skills/html-5.svg"
import L_CSS3 from "../../assets/img/skills/css3.svg";
import L_BOOTSTRAP from "../../assets/img/skills/bootstrap-4.svg";
import L_REACT from "../../assets/img/skills/react.svg";
import L_REDUX from "../../assets/img/skills/redux.svg";
import L_REACT_ROUTER from "../../assets/img/skills/react-router.svg";
import L_MATERIALUI from "../../assets/img/skills/material-ui-1.svg";
import L_Styledcomponent from "../../assets/img/skills/styled-components.svg";
import L_REACT_BOOTSTRAP from "../../assets/img/skills/react-bootstrap.svg";
import L_NODE_JS from "../../assets/img/skills/nodejs.svg";
import L_EXPRESS from "../../assets/img/skills/express.svg";
import L_MONGODB from "../../assets/img/skills/mongodb.svg";
import L_GIT from "../../assets/img/skills/git-icon.svg";
import L_GITHUB_PAGES from "../../assets/img/skills/github.svg";
import L_JAVASCRIPT from "../../assets/img/skills/javascript.svg";
import L_HEROKU from "../../assets/img/skills/heroku.svg";
import L_PYTHON from "../../assets/img/skills/python.svg";


export const skills = {
    frontend: [
        {
            link: "https://en.wikipedia.org/wiki/HTML5",
            imgAltText: "HTML 5",
            imgSrc: L_HTML5,
            skillName: "HTML5",
        },
        {
            link: "https://en.wikipedia.org/wiki/CSS",
            imgAltText: "CSS 3",
            imgSrc: L_CSS3,
            skillName: "CSS3",
        },
        {
            link: "https://www.javascript.com/",
            imgAltText: "JavaScript",
            imgSrc: L_JAVASCRIPT,
            skillName: "JavaScript",
        },
        {
            link: "https://getbootstrap.com/",
            imgAltText: "Bootstrap",
            imgSrc: L_BOOTSTRAP,
            skillName: "Bootstrap",
        },
        {
            link: "https://reactjs.org/",
            imgAltText: "React JS",
            imgSrc: L_REACT,
            skillName: "React JS",
        },
        {
            link: "https://redux.js.org/",
            imgAltText: "Redux",
            imgSrc: L_REDUX,
            skillName: "Redux",
        },
        {
            link: "https://reacttraining.com/react-router/",
            imgAltText: "React Router",
            imgSrc: L_REACT_ROUTER,
            skillName: "React Router",
        },
        {
            link: "https://material-ui.com/",
            imgAltText: "Material-UI",
            imgSrc: L_MATERIALUI,
            skillName: "Material-UI",
        },
        {
            link: "https://react-bootstrap.github.io/",
            imgAltText: "React Bootstrap",
            imgSrc: L_REACT_BOOTSTRAP,
            skillName: "React Bootstrap",
        },
        {
            link: "https://styled-components.com/",
            imgAltText: "Styled Components",
            imgSrc:  L_Styledcomponent,
            skillName: "Styled Components",
        },
    ],

    backend: [
        {
            link: "https://nodejs.org/en/",
            imgAltText: "Node.js",
            imgSrc: L_NODE_JS,
            skillName: "Node.js",
        },
        {
            link: "https://expressjs.com/",
            imgAltText: "Express",
            imgSrc: L_EXPRESS,
            skillName: "Express",
        },
    ],
    hostingPlatforms: [
        {
            link: "https://pages.github.com/",
            imgAltText: "Firebase",
            imgSrc: L_GITHUB_PAGES,
            skillName: "FireBase ",
        },
        {
            link: "https://www.heroku.com/",
            imgAltText: "Heroku",
            imgSrc: L_HEROKU,
            skillName: "Heroku ",
        },
        {
            link: "https://pages.github.com/",
            imgAltText: "Netlify",
            imgSrc: L_GITHUB_PAGES,
            skillName: "Netlify ",
        },

        {
            link: "https://pages.github.com/",
            imgAltText: "GitHub Pages",
            imgSrc: L_GITHUB_PAGES,
            skillName: "GitHub Pages",
        },
    ],
    programmingLanguages: [
        {
            link: "https://www.javascript.com/",
            imgAltText: "JavaScript",
            imgSrc: L_JAVASCRIPT,
            skillName: "JavaScript",
        },
        {
            link: "https://www.python.org/",
            imgAltText: "Python",
            imgSrc: L_PYTHON,
            skillName: "Python",
        },
    ],
    databases: [
        {
            link: "https://www.mongodb.com/",
            imgAltText: "MongoDB",
            imgSrc: L_MONGODB,
            skillName: "MongoDB",
        },
    ],
    versionControl: [
        {
            link: "https://git-scm.com/",
            imgAltText: "GIT",
            imgSrc: L_GIT,
            skillName: "GIT",
        },
    ],
};